import axios from 'axios';

const API_FINARY_URL = process.env.NEXT_PUBLIC_API_FINARY_URL;

export const getUiConfig = async () => {
  const response = await axios.get(`${API_FINARY_URL}/ui_config`);
  return response.data.result;
};
